// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-113ECd9a","dbox":"dbox-2kQ0X_-c"};